import { dataApiUrl } from 'utils/url';
import AuthAxios from 'utils/authAxios';
import { parseErrorArrayAndThrowMsg } from './utils';

const DataApiUrl = dataApiUrl();

const Releases = () => {
  const create = userGroupId =>
    AuthAxios.post(`${DataApiUrl}/admin/releases`, {
      user_group_id: userGroupId,
    })
      .then(res => res.data.data)
      .catch(err => {
        throw err.response;
      });

  const clone = releaseId =>
    AuthAxios.post(`${DataApiUrl}/admin/releases/${releaseId}/copy`)
      .then(res => res.data.data)
      .catch(err => {
        throw err.response;
      });

  const details = id =>
    AuthAxios.get(`${DataApiUrl}/admin/releases/${id}/details`)
      .then(res => res.data.data)
      .catch(err => {
        throw err.response;
      });

  const tracks = id =>
    AuthAxios.get(`${DataApiUrl}/admin/releases/${id}/tracks`)
      .then(res => res.data.data.results)
      .catch(err => {
        throw err.response;
      });

  const getAllWithQuery = params => {
    return AuthAxios.get(`${DataApiUrl}/admin/releases`, params)
      .then(res => res.data.data)
      .catch(err => {
        throw err.response;
      });
  };

  const status = id =>
    AuthAxios.get(`${DataApiUrl}/admin/releases/${id}/distributionJobs`)
      .then(res => res.data || res.data.data)
      .catch(err => {
        throw err.response;
      });

  const getById = id =>
    AuthAxios.get(`${DataApiUrl}/admin/releases/${id}`)
      .then(res => res.data.data)
      .catch(err => {
        throw err.response;
      });

  const patchRelease = (id, data) =>
    AuthAxios.patch(`${DataApiUrl}/admin/releases/${id}`, data)
      .then(res => res.data.data)
      .catch(parseErrorArrayAndThrowMsg('patch release'));

  const changeUserGroup = (id, data) =>
    AuthAxios.patch(`${DataApiUrl}/admin/releases/${id}/changeOwnership`, data)
      .then(res => res.data.data)
      .catch(parseErrorArrayAndThrowMsg('change owernship'));

  return {
    create,
    clone,
    tracks,
    getAllWithQuery,
    details,
    status,
    getById,
    patchRelease,
    changeUserGroup,
  };
};

export default Releases;
